<template>
  <div>
      <div v-if="Object.keys(archives).length > 0" >
          <div class="col-md-12 row py-10" >
              <div class="col-md-5" v-if="archives.extra !== null">
                  <v-carousel :continuous="true"
                              cycle
                              :show-arrows="archives.extra.images.length > 1"
                              hide-delimiter-background
                              delimiter-icon="mdi-minus"
                              height="auto"
                              width="auto"
                  >
                      <v-carousel-item
                              v-for="(image, i) in archives.extra.images"
                              :key="i"
                              :src="image.link"
                      >
                      </v-carousel-item>
                  </v-carousel>
              </div>
              <div class="col-md text-right">
                  <div class="row mx-auto px-0 ">
                      <p class="col-md-4 py-1"><span class="font-weight-bolder" style="color: darkblue">دسته بندی :</span>
                          <span
                                  class="font-weight-bold" v-html="translator(archives.category)"></span></p>
                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">استان : </span><span
                              class="font-weight-bold"
                              v-html="translator('city_' + archives.city)"></span></p>
                      <p class="col-md-4 py-1"><span class="font-weight-bolder" style="color: darkblue">محله : </span>
                          <span class="font-weight-bold"
                                v-html="translator('city_' + archives.city)"></span></p>
                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">بالکن : </span><span
                              class="font-weight-bold">
                    {{ archives.balcony !== null ? 'انتخاب نشده' : 'دارد' }}
                       </span></p>

                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">آسانسور : </span><span
                              class="font-weight-bold">{{ archives.elevator === 1 ? 'دارد' : 'انتخاب نشده' }}</span></p>

                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">پارکینگ : </span><span
                              class="font-weight-bold">{{ archives.parking === 1 ? 'دارد' : 'انتخاب نشده' }}</span></p>
                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">تعداد اتاق : </span><span
                              class="font-weight-bold">{{ roomTranslate(archives.rooms) }}</span></p>

                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">طبقه : </span><span
                              class="font-weight-bold">{{ floorTranslate(archives.floor) }}</span></p>

                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">متراژ : </span><span
                              class="font-weight-bold">{{ archives.size && archives.land_size }}</span></p>
                      <p class="col-md-4 py-1"><span class="font-weight-bolder" style="color: darkblue">سال ساخت : </span><span
                              class="font-weight-bold">{{ archives.year }}</span></p>

                      <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                     style="color: darkblue">مناسب برای  : </span><span
                              class="font-weight-bold">{{ archives.rent_to_single ? 'خانواده و مجرد' : 'خانواده' }}</span>
                      </p>

                      <div class="col-md-12 row" v-if='archives.extra!==null && archives.extra.other_options_and_attributes != null'>
                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">بازسازی  : </span><span
                                  class="font-weight-bold">{{
                                  archives.extra.other_options_and_attributes.rebuilt ? 'نشده است' : 'شده است'
                              }}</span></p>
                          <p class="col-md-4 py-1"><span class="font-weight-bolder" saaaas
                                                         style="color: darkblue">مبلغ نهایی  : </span><span
                                  class="font-weight-bold">{{
                                  archives.new_price !== null ? archives.new_price : 'انتخاب نشده'
                              }}</span></p>

                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">جهت ساختمان  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.building_direction)
                              }}</span></p>

                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">سیستم سرمایشی  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.cooling_system)
                              }}</span></p>
                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">سیستم گرمایشی  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.heating_system)
                              }}</span></p>

                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">جنس کف  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.floor_type)
                              }}</span></p>

                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">تعداد کل طبقات ساختمان  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.floors_count)
                              }}</span></p>

                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">تعداد واحد در طبقه  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.unit_per_floor)
                              }}</span></p>

                          <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                         style="color: darkblue">ودیعه  : </span><span
                                  class="font-weight-bold">{{
                                  archives.rent !== null ? archives.rent : 'انتخاب نشده'
                              }}</span></p>

                          <p
                                  class="col-md-4 py-1"><span class="font-weight-bolder"
                                                              style="color: darkblue">سرویس بهداشتی  : </span><span
                                  class="font-weight-bold">{{
                                  directionTranslate(archives.extra.other_options_and_attributes.toilet)
                              }}</span></p>
                      </div>


                    <div v-if="archives.title!== null" class="pr-3">
                        <p class=" py-1"><span class="font-weight-bolder"
                                                       style="color: darkblue">عنوان : </span><span
                                class="font-weight-bold">{{ archives.title }}</span></p>
                    </div>

                  </div>
                <div v-if="archives.description!== null">
                    <p class="pr-3 pt-2" ><span class="font-weight-bolder"
                                                                                   style="color: darkblue">توضیحات : </span>
                    <p class="font-weight-bold py-0 col-md pr-3" v-for="(line) in archives.description.split('\n')"
                       :key="line">
                        {{
                            line
                        }}</p>
                </div>
              </div>
          </div>
      </div>
      <div class="col-md-6 py-10 mx-auto" v-else>
          <p class="text-center">در حال بارگیری اطلاعات</p>
          <v-progress-linear
                  indeterminate
                  height="5"
                  striped
                  color="indigo"
          ></v-progress-linear>
      </div>
  </div>
</template>

<script>

import {Axios2} from "../../../../main";

export default {
    name: "moreInformation",
    props: {
        information: {
            default: ''
        },
        bought: {
            default: false,
        },
        archive: {
            default: false,
        }
    },
    data() {
        return {
            archives: {},
            translates: [],
            downloadUrl: '',
            name: 'بانک',
            loading:false
        }
    },
    methods: {
        getArchives() {
            this.loading=true
            Axios2.get(`user/estate/${this.information}`).then((response) => {
                this.loading=false
                this.archives = response.data.data;
            });
        },
        getArchived() {
            Axios2.get(`user/archived/${this.information}`).then((response) => {
                this.archives = response.data.data;
            });
        },
        translator(name) {
            return this.translates[name];
        },
        floorTranslate(floor) {
            return {0: 'همکف', '-1': 'زیر همکف'}[floor] ?? floor
        },
        roomTranslate(room) {
            return [
                "بدون اتاق",
                "یک",
                "دو",
                "سه",
                "چهار",
                "پنج یا بیشتر"
            ][room]
        },
        directionTranslate(direction) {
            return {
                "north": "شمالی",
                "south": "جنوبی",
                "east": "شرقی",
                "west": "غربی",
                "heater": "بخاری",
                "shoofaj": "شوفاژ",
                "fan_coli": "فن کوئل",
                "floor_heating": "از کف",
                "duct_split": "داکت اسپلیت",
                "split": "اسپلیت",
                "fireplace": "شومینه",
                "ceramic": "سرامیک",
                "wood_parquet": "پارکت چوبی",
                "laminate_parquet": "پارکت لمینت",
                "stone": "سنگ",
                "floor_covering": "کف پوش pvc",
                "carpet": "موکت",
                "mosaic": "موزائیک",
                "water_cooler": "کولر آبی",
                "air_conditioner": "کولر گازی",
                "fan_coil": "فن کوئل",
                "unselect": "انتخاب نشده",
                "1": "۱",
                "2": "۲",
                "3": "۳",
                "4": "۴",
                "5": "۵",
                "6": "۶",
                "7": "۷",
                "8": "۸",
                "9": "۹",
                "10": "۱۰",
                "11": "۱۱",
                "12": "۱۲",
                "13": "۱۳",
                "14": "۱۴",
                "15": "۱۵",
                "16": "۱۶",
                "17": "۱۷",
                "18": "۱۸",
                "19": "۱۹",
                "20": "۲۰",
                "21": "۲۱",
                "22": "۲۲",
                "23": "۲۳",
                "24": "۲۴",
                "25": "۲۵",
                "26": "۲۶",
                "27": "۲۷",
                "28": "۲۸",
                "29": "۲۹",
                "30": "۳۰",
                "30+": "بیشتر از ۳۰",
                "more_than_8": "بیشتر از ۸",
                "squat": "ایرانی", "seat": "فرنگی", "squatlable": "ایرانی و فرنگی",
            }[direction]
        },
        buyProduct(id) {
            this.$modal.yesNo('تایید خرید!', 'آیا از خرید این بانک اطلاعاتی اطمینان دارید؟ پس از خرید، عودت مبلغ تحت هیچ شرایطی امکان پذیر نمی باشد.', 'neg').then((x) => {
                if (x === true) {
                    Axios2.put(`user/shop/${id}`).then((res) => {
                        this.$nextTick(() => {
                            this.$modal.success('موفق!', res.data.message);
                        })

                    }).catch((error) => {
                        this.$nextTick(() => {
                            this.$modal.error('خطا!', '', error.response.data.message)
                        })
                    });
                }
            })
        },
        downloader(id) {
            Axios2.post(`/user/estate/${id}`, [], {
                responseType: "blob",
            }).then((x) => {
                this.name = decodeURI(x.headers["name"]);
                this.downloadUrl = window.URL.createObjectURL(new Blob([x.data]));
                this.$nextTick(() => {
                    this.$refs.dl.click();
                })
            })
        },
    },
    beforeMount() {
        if (this.archive) {
            this.getArchived();
        } else
            this.getArchives();
    },
    mounted() {

        this.downloadUrl = '';
        if (localStorage.getItem('localization')) {
            this.translates = JSON.parse(localStorage.getItem('localization'));
            return;
        }
    }
}
</script>

<style scoped>

</style>